export default __webpack_public_path__ + "static/media/icon-password.b56815b2.png";